<template>
  <div 
    class="video-vimeo-player"
    :class="{
      'video-vimeo-player--auto-height': autoHeight
    }
  ">
    <app-full-sticky-bg isPlay @startPlay="onStartPlay" />
    <HMTVimeoPlayer v-if="played" :url="url" />
  </div>
</template>

<script>
  import HMTVimeoPlayer from '@/shared/components/VideoProvider/components/VimeoPlayer';
  import FullStickyBg from '@/components/fullStickyBg/fullStickyBg'

  export default {
    components: {
      HMTVimeoPlayer,
      appFullStickyBg: FullStickyBg
    },
    props: {
      url: {
        default: '',
        type: String
      },
      autoHeight: {
        default: false,
        type: Boolean
      }
    },
    data () {
      return {
        played: false
      }
    },
    methods: {
      onStartPlay () {
				this.played = true;
			}
    }
  }
</script>

<style lang="scss">
  .video-vimeo-player {

    .full-sticky-bg {
			position: absolute;
			z-index: 5;
		}

    &--auto-height {
      height: auto;
      padding-top: 56.25%;
      width: auto;

      .hmt-vimeo-player {
        &:not(:fullscreen) iframe {
          width: 100%;
          height: 100%;
          min-height: 100%;
          min-width: 100%;
          top: 0;
          left: 0;
          transform: translate(0, 0);
        }
      }
    }

    // .hmt-vimeo-player {
    //   position: relative;
    //   width: 100%;
    //   height: auto;
    //   padding-top: 56.25%;
    //   background-color: #000;
    // }
  }
</style>
